import React from "react";
import Header from "./components/Header";
import StatsReset from "./components/StatsReset";
import PlatformFeatures from "./components/PlatformFeatures";
import Pathway from "./components/Pathway";
import AcceleratorProgram from "./components/AcceleratorProgram";
import HumanitarianReset from "./components/HumanitarianReset";
import ClosingCTA from "./components/ClosingCTA";
import Footer from "./components/Footer";
import { LanguageProvider, useLanguage } from "./i18n/LanguageContext";

function LandingInner() {
   const { dir, lang } = useLanguage();
   return (
      <div className="App">
         <div
            className={`sudan-kaporg sudan-landing ${lang === "ar" ? "sudan-rtl" : ""}`}
            dir={dir}
         >
            <Header />
            <StatsReset />
            <PlatformFeatures />
            <Pathway />
            <AcceleratorProgram />
            <HumanitarianReset />
            <ClosingCTA />
            <Footer />
         </div>
      </div>
   );
}

function LoginSudan() {
   return (
      <LanguageProvider>
         <LandingInner />
      </LanguageProvider>
   );
}

export default LoginSudan;
